'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var teachers = exports.teachers = {
  title: 'Teachers',
  description: 'Become a teacher and show your skills, while making money',
  reasons_title: 'Advantages of being a teacher',
  make_title: 'Record your own course',
  make_description: 'Use a camara, webcam or phone. Record yourself in small segments. Be careful with the sound and edit the result. We will teach you how.',
  branding_title: 'Make your brand stronger',
  branding_description: 'Write your own blog at Tutellus. Create your own space. We will promote it in order to get you new users.',
  profit_title: 'Earn money by teaching',
  profit_description: 'We will give you all the tools you will need to publish and promote your course without fees. You will receive 70% of the sales, always.',
  become_teacher: 'Become a teacher',
  metrics_title: 'Metrics of your courses',
  metrics_description: 'Keep track of the main metrics of your courses (Conversion, Recurrence, Advance...) and make your own conclusions to improve your relationship with both current students and potential new users.',
  profits_title: 'Keep track of your profits',
  profits_description: 'You will get a "wallet" to keep track of your earnings and find out the best channels for your courses.',
  promotions_title: 'Coupons, Affiliates and Promos',
  promotions_description: 'Use the services at your disposal to create a bigger community and find new users. The more you use it, the better it will work.',
  community_title: 'Interacting with your community',
  community_description: 'Each course is its own universe with students wanting to interact with you. Help them and they will help you get new users through the recommendation system.',
  testimonials_title: 'Our teachers give their opinion on Tutellus',
  sergio_name: 'Sergio Fernández',
  sergio_job: 'Entreprenour',
  sergio_testimonial: 'Tutellus is revolutionizing the way we teach and learn. It is easy, intuitive and has a great support team. Without any doubt the best platform I know. 100% recommend',
  david_name: 'David Sevilla',
  david_job: 'Programmer',
  david_testimonial: 'I heard of Tutellus from my mother, and I paid them a visit at their offices. They have helped me a lot with the programming courses, and one day I want to be as good a programmer as Javier Ortiz.',
  dany_name: 'Dany Campos',
  dany_job: 'Scriptwriter',
  dany_testimonial: 'Tutellus grants me the tools I need to bring my material to all users. Thanks to its interface and the people making it work, I now have extra monthly income!',
  eva_name: 'Eva García',
  eva_job: 'Writer',
  eva_testimonial: 'In Tutellus, I found the perfect tool to launch my course, reaching potential students. It is really easy to use the platform and its services.'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/teachers.js
// module id = 721
// module chunks = 0